// extracted by mini-css-extract-plugin
export default {"column":"DriversListCard_column__y05BQ","name":"DriversListCard_name__IRKT6","details":"DriversListCard_details__zw+qN","footer":"DriversListCard_footer__Za+s1"};